import "reflect-metadata";
import {inject, injectable} from "inversify";
import {TicketRepository} from "@dropDesk/domain/repositories/ticket/ticket.repository";
import {ExportTicketStatusEntity} from "@dropDesk/domain/entities/ticket/export_ticket_status.entity";

@injectable()
export class GetCurrentExportStateTicketsUseCase {
    private _repository: TicketRepository;

    constructor(@inject(TicketRepository) repository: TicketRepository) {
        this._repository = repository;
    }

    public call(): Promise<ExportTicketStatusEntity | null> {
        return this._repository.getCurrentExportState();
    }
}
